/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MODERATOR" | "STAFF" | "%future added value";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "%future added value";
declare const _CreateCommentMutation_viewer$ref: unique symbol;
export type CreateCommentMutation_viewer$ref = typeof _CreateCommentMutation_viewer$ref;
export type CreateCommentMutation_viewer = {
    readonly role: USER_ROLE;
    readonly createdAt: string;
    readonly badges: ReadonlyArray<string> | null;
    readonly status: {
        readonly current: ReadonlyArray<USER_STATUS>;
        readonly ban: {
            readonly active: boolean;
        };
    };
    readonly " $refType": CreateCommentMutation_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CreateCommentMutation_viewer",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "role",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "badges",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "status",
            "storageKey": null,
            "args": null,
            "concreteType": "UserStatus",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "current",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "ban",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BanStatus",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "active",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '074f5279aab94f8b50e2cdaf6ceff490';
export default node;
